// extracted by mini-css-extract-plugin
module.exports = {"truncateContainer":"EditNewLocationModal_truncateContainer__Wa120","truncate":"EditNewLocationModal_truncate__2GMDr"};